(function bsgSwatches() {
  var wraps = document.querySelectorAll('.bsg-color-swatch-wrap');
  if (!wraps.length) return;

  var MAX = 10;
  var FALLBACK = '#D0C8C0';

  var HEX = {
    // PLA Basic (official Bambu Lab hex codes)
    'jade white':       '#FFFFFF',
    'beige':            '#F7E6DE',
    'light gray':       '#D1D3D5',
    'silver':           '#A6A9AA',
    'gray':             '#8E9089',
    'dark gray':        '#545454',
    'black':            '#000000',
    'magenta':          '#EC008C',
    'pink':             '#F55A74',
    'hot pink':         '#F5547C',
    'orange':           '#FF6A13',
    'pumpkin orange':   '#FF9016',
    'gold':             '#E4BD68',
    'sunflower yellow': '#FEC600',
    'yellow':           '#F4EE2A',
    'bright green':     '#BECF00',
    'bambu green':      '#00AE42',
    'mistletoe green':  '#3F8E43',
    'bronze':           '#847D48',
    'cocoa brown':      '#6F5034',
    'brown':            '#9D432C',
    'maroon red':       '#9D2235',
    'red':              '#C12E1F',
    'turquoise':        '#00B1B7',
    'cyan':             '#0086D6',
    'blue':             '#0A2989',
    'cobalt blue':      '#0056B8',
    'purple':           '#5E43B7',
    'indigo purple':    '#482960',
    'blue grey':        '#5B6579',
    // PLA Matte (official Bambu Lab hex codes)
    'ivory white':      '#FFFFFF',
    'bone white':       '#CBC6B8',
    'desert tan':       '#E8DBB7',
    'latte brown':      '#D3B7A7',
    'caramel':          '#AE835B',
    'terracotta':       '#B15533',
    'dark brown':       '#7D6556',
    'dark chocolate':   '#4D3324',
    'lilac purple':     '#AE96D4',
    'sakura pink':      '#E8AFCF',
    'mandarin orange':  '#F99963',
    'lemon yellow':     '#F7D959',
    'plum':             '#950051',
    'scarlet red':      '#DE4343',
    'dark red':         '#BB3D43',
    'dark green':       '#68724D',
    'grass green':      '#61C680',
    'apple green':      '#C2E189',
    'ice blue':         '#A3D8E1',
    'sky blue':         '#56B7E6',
    'marine blue':      '#0078BF',
    'dark blue':        '#042F56',
    'ash gray':         '#9B9EA0',
    'nardo gray':       '#757575',
    'charcoal':         '#000000'
  };

  function buildSwatches(wrap) {
    if (wrap.dataset.bsgDone) return;
    wrap.dataset.bsgDone = '1';

    var card = wrap.closest('product-card');
    if (!card) return;

    var raw = card.getAttribute('data-colors') || '';
    if (!raw) return;

    var colors = raw.split(',').map(function(s) { return s.trim(); });
    var shown = colors.slice(0, MAX);
    var overflow = colors.length - shown.length;

    shown.forEach(function(name) {
      var hex = HEX[name.toLowerCase()] || FALLBACK;
      var span = document.createElement('span');
      span.className = 'bsg-swatch';
      span.style.background = hex;
      span.title = name;
      wrap.appendChild(span);
    });

    if (overflow > 0) {
      var more = document.createElement('span');
      more.className = 'bsg-swatch-more';
      more.textContent = '+' + overflow + ' more';
      wrap.appendChild(more);
    }
  }

  var isMobile = window.matchMedia('(pointer: coarse)').matches || window.innerWidth <= 749;

  wraps.forEach(function(wrap) {
    if (isMobile) {
      buildSwatches(wrap);
    } else {
      var card = wrap.closest('product-card');
      if (!card) return;
      card.addEventListener('mouseenter', function() {
        buildSwatches(wrap);
      }, { once: true });
    }
  });
})();
